import { render, staticRenderFns } from "./loan-term-info-sub-section.vue?vue&type=template&id=22e1041a"
import script from "./loan-term-info-sub-section.vue?vue&type=script&lang=js"
export * from "./loan-term-info-sub-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports